import * as Flux from 'dg-web-shared/lib/Flux.tsx';

export namespace Edit {
    export interface State {
        allowedPermitTypes?: number[] | null;
        allowedProductTypes?: number[] | null;
        allowedZones?: number[] | null;
        allowedRecodeConditions?: string[] | null;
        permOperatorAppActive?: boolean | null;
        permEnforcementAppActive?: boolean | null;
        permTransactions?: boolean | null;
        permRefundParkTransactions?: boolean | null;
        permPermissionsEdit?: boolean | null;

        permParkingpay?: boolean | null;
        permPermitsRead?: boolean | null;
        permPermitsWrite?: boolean | null;
        permRefundPermits?: boolean | null;
        permActivityStatement?: boolean | null;
        permWhitelistCreate?: boolean | null;
        permWhitelistDelete?: boolean | null;
        permEnforcementLog?: boolean | null;
        permTwintQrCodePairing?: boolean | null;
        permQuotasWrite?: boolean | null;
        permParkingaboInitialBalanceCreate?: boolean | null;
        permCloudConnectorOffstreetDevicesView?: boolean | null;
        permCloudConnectorRecodeTicket?: boolean | null;
        permCloudConnectorAlerts?: boolean | null;
        permCloudConnectorReportingAccess?: boolean | null;
        permMasterDataAndStatistics?: boolean | null;
        permParkingaboUserEdit?: boolean | null;

        permTaxomex?: boolean | null;
        permSyncApp?: boolean | null;
        permUsbStickEdit?: boolean | null;
        permParkingMeterEdit?: boolean | null;
        permParkingMeterAlerts?: boolean | null;

        firstName?: string | null;
        lastName?: string | null;
        username?: string | null;
        zipCode?: string | null;
        description?: string | null;
        softAnonymizeCheckinPublicPermitAfterDays?: string | null;
        city?: string | null;
        telnr?: string | null;
        email?: string | null;
    }

    export const { set, get, reset, stateWrite } = Flux.generateState<State>(
        'operator-logins/OperatorLoginsState.Edit',
        {},
    );
}
